import { BookingContainer } from './booking.container';
import { FormsModule } from '@angular/forms';
import { SingleResultService } from './../../core/services/single-hotel.service';
import { BookingInfoComponent } from './shared/booking-info.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BookingConfirmationComponent } from './voucher/booking-confirmation.component';
import { BookingComponent } from './booking.component';

import { SharedModule } from './../../shared/components/shared.module';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { BookingInitComponent } from './booking-init.component';
import { NgxSpinnerModule } from 'ngx-spinner';

const routes: Routes = [
  {
    path: 'booking', component: BookingInitComponent, children: [
      { path: ':id', component: BookingComponent },
      { path: 'booked/:id', component: BookingConfirmationComponent }
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
    NgbModule,
    SharedModule,
    FormsModule,
    NgxSpinnerModule

  ],
  exports: [],
  declarations: [
    BookingComponent,
    BookingConfirmationComponent,
    BookingInfoComponent,
    BookingInitComponent
  ],
  providers: [SingleResultService, BookingContainer],
})
export class BookingModule { }
